import { BaseDevice } from '../common';
import { Context } from '../common/context.model';
import { Status } from '../common/status.model';
import { DeviceVariable } from './device-variable.model';
import { Site } from './site.model';

export interface Device extends BaseDevice {
  connector: string;
  context?: Context;
  expandedVariables: { [key: string]: Partial<DeviceVariable> } | NonNullable<unknown>;
  lastConfStatus?: Status;
  serviceId?: string;
  sharedAuthentication?: boolean;
  site?: Site;
  status?: DeviceStatus;
}

export interface DeviceStatus extends Status {
  name: DeviceStatusName;
}

export enum DeviceStatusName {
  test_mode = 'test_mode',
  standby = 'standby',
  running = 'running',
  maintenance = 'maintenance',
  decommissioned = 'decommissioned'
}
